// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__fkw67","pulse":"styles_pulse__o8D78","jump":"styles_jump__Q0ECY","wiggle":"styles_wiggle__XxCHb"};